'use client'

import { useCallback } from 'react'

import { LOCALE_KEY, DEFAULT_LOCALE } from 'src/constants/session'

import useAppStorage from './useAppStorage'

type Locale = 'en-US' | 'en'

const useLocale = () => {
  const { getItem, setItem } = useAppStorage()

  const getLocale = useCallback((): Locale | undefined => {
    const locale = getItem(LOCALE_KEY) as Locale | undefined
    return locale
  }, [getItem])

  const updateLocale = useCallback((newLocale: Locale) => {
    const storedLocale = getLocale()
    if (newLocale === DEFAULT_LOCALE && storedLocale === DEFAULT_LOCALE) {
      setItem(LOCALE_KEY, newLocale)
    }
  }, [getLocale, setItem])

  return {
    locale: getLocale(),
    defaultLocale: DEFAULT_LOCALE,
    updateLocale,
    resetLocale: () => {
      setItem(LOCALE_KEY, DEFAULT_LOCALE)
    },
  }
}

export default useLocale
